module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA2.8d19a27c.jpg";